<template>
  <v-row 
    no-gutters 
    :justify="ieAlign" 
    :align="ieAlign" 
    class="control-toolbar secondary">
    <v-col cols="auto" class="mr-2">
      <v-btn text 
        class="modal-cta" 
        :class="[{ active: isOD }, colorClass]" 
        @click="selectOD">OD</v-btn>
      <v-btn text 
        class="modal-cta" 
        :class="[{ active: !isOD }, colorClass]" 
        @click="selectOS">OS</v-btn>
    </v-col>
    <v-col cols="auto" class="mr-2" v-if="lockEnabled">
      <v-btn text
        class="modal-cta"
        :class="[{ active: isLocked }, colorClass]" 
        @click="toggleLocked">Lock Scans</v-btn>
    </v-col>
    <v-col cols="auto" class="mr-2" v-if="isSpectralisComparison">
      <select-with-button
        :value="spectralisScanTypeFilter"
        @change="selectScanTypeFilter"
        :items="spectralisScanTypes"
        :icon-button="true"
        class="toolbar-select"/>
    </v-col>
    <v-col cols="auto" class="mr-2" v-if="showFoveaAlignControl">
      <span class="difference-map-alignment">Difference Map Alignment:</span>
    </v-col>
    <v-col cols="auto" class="mr-2" v-if="showFoveaAlignControl">
      <select-with-button
        :value="alignFoveasString"
        @change="selectAlign"
        :items="alignFoveaOptions"
        :icon-button="true"
        class="toolbar-select"/>
    </v-col>
    <v-flex shrink ml-auto>
      <v-btn text @click="singleView">
        <v-avatar size="30" class="mr-1">
          <img :src="require('../../../assets/' + coloredAssetUrls.singleView)" />
        </v-avatar>Return to Single View
      </v-btn>
    </v-flex>
  </v-row>
</template>

<script>
import { EyeTypes } from "../../../config/config";
import selectWithButton from "../../controls/SelectWithButton";
import { mapGetters } from "vuex";
export default {
  name: "octComparisonToolbar",
  components: { selectWithButton },
  data() {
    return {
      alignFoveaOptions: [
        { text: "Fovea", value: "true" },
        { text: "None", value: "false" }
      ],
      allExams: "All"
    };
  },
  computed: {
    ...mapGetters([
      "currentEye",
      "isLocked",
      "lockEnabled",
      "compare_loading",
      "baseline_loading",
      "showFoveaAlignControl",
      "alignFoveas",
      "isIE",
      "isSpectralisComparison",
      "spectralisScanTypes",
      "spectralisScanTypeFilter",
      "octExamsSameType"
    ]),
    isOD() {
      return this.currentEye === EyeTypes.OD;
    },
    octDataLoading() {
      return this.compare_loading || this.baseline_loading;
    },
    alignFoveasString(){
      return this.alignFoveas + "";
    },
    ieAlign() {
      if (!this.isIE) return null;
      return "center";
    }
  },
  methods: {
    selectOD() {
      if (!this.octDataLoading) {
        let exSrNo = this.$store.getters.baseline ? this.$store.getters.baseline.exam.exSrNo : this.$store.getters.compare.exam.exSrNo ; 
        this.$store.dispatch("selectOCTEyeCompare", "OD");
        this.$store.dispatch("selectOCTExamCompare", {exSrNo: exSrNo, name: this.$store.getters.baseline ? "baseline" : "compare"});
      }
    },
    selectOS() {
      if (!this.octDataLoading) {
        let exSrNo = this.$store.getters.baseline ? this.$store.getters.baseline.exam.exSrNo : this.$store.getters.compare.exam.exSrNo ; 
        this.$store.dispatch("selectOCTEyeCompare", "OS");
        this.$store.dispatch("selectOCTExamCompare", {exSrNo: exSrNo, name: this.$store.getters.baseline ? "baseline" : "compare"});
      }
    },
    toggleLocked() {
      this.$store.dispatch("toggleLocked");
    },
    singleView() {
      if (!this.octDataLoading) this.$store.dispatch("toggleOCTMultiview");
    },
    selectAlign(val) {
      this.$store.commit("updateFoveaAlignment", val === "true");
    },
    selectScanTypeFilter(val) {
      this.$store.commit("updateScanTypeFilter", val);
      let filteredExams = this.octExamsSameType;
      // Check if currently selected exam is of specified scan type.
      let currentExam = filteredExams.filter(e => e.exSrNo == this.$store.getters.compare.exam.exSrNo && e.scanType == this.$store.getters.compare.group.scanType);
      if (currentExam.length == 0 && filteredExams.length > 0) {
        // Reselect to valid exam if not.
        this.$store.dispatch("selectOCTExamCompareWithExamText", {examText: filteredExams[0].octDateButtonText, name: "compare"});

        // Recreate baseline context with another exam, or nothing if there is only 1 exam.
        if (filteredExams.length > 1)
          this.$store.dispatch("selectOCTExamCompareWithExamText", {examText: filteredExams[1].octDateButtonText, name: "baseline"});
        else
          this.$store.dispatch("selectOCTExamCompareWithExamText", {examText: null, name: "baseline"});
      }
      else if (currentExam.length != 0 && val != this.allExams) {
        this.$store.dispatch("selectSpectralisGroupCompare", {groupName: val, name: "compare"});
        this.$store.dispatch("selectSpectralisGroupCompare", {groupName: val, name: "baseline"});
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  .difference-map-alignment {
    display: inline-block;
    margin-top: 9px;
  }
</style>